import CardsList from "@/components/cardsList";
import { CHOOSE_ON_DEMAND_CONSTANTS } from "./constants";

const OnDemandCards = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 3 }}
      list={CHOOSE_ON_DEMAND_CONSTANTS.list}
      spacing={{ base: 8, md: 12 }}
      title={CHOOSE_ON_DEMAND_CONSTANTS.title}
    />
  );
};

export default OnDemandCards;
